/**
 * Public barrel export for MobileFilter — the single player-filter surface (SE-5548).
 * @module components/MobileFilter
 */
export { default } from "./MobileFilterContainer";
